import { memo,useState,useRef } from "react"; 
import { Routes,Route,Link} from "react-router-dom";
import './HeaderComponent.css';
import MainComponent from "./MainComponent";
import PackagesComponent from "./PackagesComponent";
import CustomerComponent from "./CustomerComponent";
import HostingComponent from "./HostingComponent";



const HeaderComponent = (props) =>{

    const[modalStyle,setModalStyle] = useState();
    const BackdropElem = useRef('');
    const MobileNavElem = useRef('');

    const ChoosePlanClicked = ()=>{
        setModalStyle({
            opacity : '1',
            transform:'translateY(0)'
        })
        BackdropElem.current.style.display = 'block';
    }

    function CancelPlanClicked(){
        setModalStyle({
            opacity : '0',
            transform:'translateY(-3rem)'
        });
        BackdropElem.current.style.display = 'none';
    }

    function MobileToggleClicked(){
        BackdropElem.current.style.display = 'block';
        MobileNavElem.current.style.display = 'block';
    }

    function BackDropClicked(){
        setModalStyle({
            opacity : '0',
            transform:'translateY(-3rem)'
        });
        BackdropElem.current.style.display = 'none';
        MobileNavElem.current.style.display = 'none';
    }

    function handleMobileNav(){
        BackdropElem.current.style.display = 'none';
        MobileNavElem.current.style.display = 'none';
    }

    return(
        <div>
            <div className='backdrop' onClick={BackDropClicked} ref={BackdropElem} ></div>
            <div className="modal" style={modalStyle}>
                <h1 className="modal__title">Do you want to continue?</h1>
                <div className="modal__actions">
                    <a href="/hosting" className="modal__action">Yes!</a>
                    <button onClick={CancelPlanClicked} className="modal__action modal__action--negative" type="button">No!</button>
                </div>
            </div>
            
            <header className="main-header">
                <div>
                    <button onClick={MobileToggleClicked} className="toggle-button">
                        <span className="toggle-button__bar"></span>
                        <span className="toggle-button__bar"></span>
                        <span className="toggle-button__bar"></span>
                    </button>
                    <Link to="/" className="main-header__brand">
                        uHost
                    </Link>
                </div> 
                <nav className="main-nav">
                    <ul className="main-nav__items">
                        <li className="main-nav__item">
                            <Link to="/packages" >Packages</Link>
                        </li>
                        <li className="main-nav__item">
                            <Link to='/customer'>Customers</Link>
                        </li>
                        <li className="main-nav__item main-nav__item--cta">
                            <Link to='/hosting'>Start Hosting</Link>
                        </li>
                    </ul>
                </nav>
            </header>
            <nav className="mobile-nav" ref={MobileNavElem}>
                <ul className="mobile-nav__items">
                    <li className="mobile-nav__item">
                        <Link to="/packages" onClick={handleMobileNav}>Packages</Link>
                    </li>
                    <li className="mobile-nav__item">
                        <Link to='/customer' onClick={handleMobileNav}>Customers</Link>
                    </li>
                    <li className="mobile-nav__item mobile-nav__item--cta">
                        <Link to='/hosting' onClick={handleMobileNav}>Start Hosting</Link>
                    </li>
                </ul>
            </nav>

            <Routes>
                <Route path='/' element={<MainComponent ChoosePlanClicked={ChoosePlanClicked} />} />
                <Route path='packages' element={<PackagesComponent />} />
                <Route path="customer" element={<CustomerComponent/>} />
                <Route path='hosting' element={<HostingComponent/>} />
            </Routes>
            
        </div>
    )
}

export default memo(HeaderComponent);